import React, { useState } from 'react';

import activateIcon from 'images/icons/invite/activate.svg';
import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';

import ModalWithoutTitle from 'components/ui/ModalWithoutTitle';
import { useContext } from '../../Context';

export default function Actions({ row, startEdit }) {
  const { dispatch, actions, state } = useContext();
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const showActivatePlanInfo = () => {
    setShowActivateModal(true);
  };

  const activatePlan = () => {
    if (state.policy.attributes.is_lock) {
      return;
    }
    setLoading(true);
    actions.activatePlan(dispatch, state.enterpriseId, row.id, () => {
      setLoading(false);
      setShowActivateModal(false);
      actions.load(dispatch, state.enterpriseId);
    });
  };

  const editPlan = (e, row) => {
    if (state.policy.attributes.is_lock) {
      return;
    }
    startEdit(row);
  };

  const deletePlan = (e, row) => {
    if (state.policy.attributes.is_lock) {
      return;
    }
    swal(
      {
        title: '',
        text: 'Do you want to delete this policy plan?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.destroyPlan(dispatch, state.enterpriseId, row.id, () => {
            actions.load(dispatch, state.enterpriseId);
          });
        }
      },
    );
  };

  return (
    <>
      <div>
        {row.attributes.id != '0' && row.attributes.status == 'draft' && (
        <a
          data-tip={state.policy.attributes.is_lock ? 'Unlock policy first' : null}
          className="mr10"
          onClick={(e) => {
            if (state.policy.attributes.is_lock) {
              return;
            }
            showActivatePlanInfo();
          }}
        >
          <img src={activateIcon} />
        </a>
        )}
        <a
          data-tip={state.policy.attributes.is_lock ? 'Unlock policy first' : null}
          onClick={(e) => editPlan(e, row)}
          className="mr10 "
        >
          <img src={editIcon} />
        </a>
        {row.attributes.id != '0' && row.attributes.status == 'draft' && (
        <a
          data-tip={state.policy.attributes.is_lock ? 'Unlock policy first' : null}
          className="mr10"
          onClick={(e) => deletePlan(e, row)}
        >
          <img src={deleteIcon} />
        </a>
        )}
      </div>
      <ModalWithoutTitle show={showActivateModal} onHide={() => setShowActivateModal(false)}>
        <div className="build_program-modal create_program-modal">
          <div className="programModal_title text-h3">Activate</div>

          <div className="programModal_txt">
            <p>Get ready to put a new plan into action!</p>
            <div className="text-left">
              <div className="mt20">
                Plan name:
                <b className="pl5">{row.attributes.name}</b>
              </div>
              <div>
                Effective Date:
                <b className="pl5">{row.attributes.effective_date_formatted}</b>
              </div>
              <div>
                Members Covered:
                <b className="pl5">{row.attributes.employees_covered_title}</b>
              </div>
              <div className="mt20">
                One important note: to ensure everything runs smoothly,
                please make sure an administrator or manager is assigned to your enterprise.
                This will ensure that invoices are generated and processed on time.
              </div>
            </div>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-green btn-outline w-100 mr5"
              onClick={() => setShowActivateModal(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-green w-100 ml5"
              onClick={() => activatePlan()}
              disabled={loading}
            >
              {loading ? 'Activate ...' : 'Activate' }
            </button>
          </div>
        </div>
      </ModalWithoutTitle>
    </>
  );
}
